import React, { useEffect, useState, useRef, memo } from 'react';
export const MultiBanner = memo(function MultiBanner() {
  const banners = [{
    id: 1,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }, {
    id: 2,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }, {
    id: 3,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }, {
    id: 4,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }, {
    id: 5,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }, {
    id: 6,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    bgColor: 'bg-gray-300'
  }];
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [activePage, setActivePage] = useState(0);
  const CARDS_PER_PAGE_MOBILE = 2;
  const totalPages = Math.ceil(banners.length / CARDS_PER_PAGE_MOBILE);
  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const page = Math.round(el.scrollLeft / el.clientWidth);
    setActivePage(page);
  };
  const goToPage = (page: number) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTo({
      left: page * el.clientWidth,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full" data-id="element-2451" data-mp="3i21nedde0iuh">
      <div className="container mx-auto px-4" data-id="element-2452" data-mp="3dzdfq90ethz3">
        {/* Desktop: 6-col grid */}
        <div className="hidden md:grid md:grid-cols-6 gap-3" data-id="element-2453" data-mp="2any8lebuj3vy">
          {banners.map(banner => <a key={banner.id} href="#" className={`rounded-lg overflow-hidden relative ${banner.bgColor} transition-transform hover:scale-105`} style={{
          willChange: 'transform'
        }} data-id="element-2454" data-mp="2fmj2kw0i8rby">
              <div className="w-full h-32" data-id="element-2455" data-mp="1rx6trx93ala6"></div>
              <div className="absolute inset-0 flex flex-col justify-center p-3 text-gray-800" data-id="element-2456" data-mp="1ryhvlriz5iyn">
                <span className="text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded-full w-max mb-2" data-id="element-2457" data-mp="1wx2xrwhsecpq">
                  {banner.subtitle}
                </span>
                <h3 className="text-sm font-bold mb-1" data-id="element-2458" data-mp="25p4w9p8apixd">{banner.title}</h3>
                <p className="text-xs font-medium" data-id="element-2459" data-mp="25qg1lthe2yql">{banner.description}</p>
              </div>
            </a>)}
        </div>

        {/* Mobile: Paginated Slider */}
        <div className="md:hidden" data-id="element-2460" data-mp="1d6hgmpc2iw3o">
          <div ref={scrollerRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" data-id="element-2461" data-mp="15oj9grhczx3m">
            {Array.from({
            length: totalPages
          }).map((_, pageIdx) => {
            const pageItems = banners.slice(pageIdx * CARDS_PER_PAGE_MOBILE, pageIdx * CARDS_PER_PAGE_MOBILE + CARDS_PER_PAGE_MOBILE);
            return <div key={pageIdx} className="flex-shrink-0 w-full snap-start grid grid-cols-2 gap-3 px-1" data-id="element-2462" data-mp="mri2j148vmx1" data-mpi={pageIdx}>
                  {pageItems.map(banner => <a key={banner.id} href="#" className={`block rounded-lg overflow-hidden relative ${banner.bgColor}`} data-id="element-2463" data-mp="d0dllvv0drzk">
                      <div className="w-full h-40" data-id="element-2464" data-mp="41iemhk54dv7"></div>
                      <div className="absolute inset-0 flex flex-col justify-center p-3 sm:p-4 text-gray-800" data-id="element-2465" data-mp="3v6s13z8xea02">
                        <span className="text-[10px] sm:text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded-full w-max mb-2" data-id="element-2466" data-mp="1z3wzo76v20vq">
                          {banner.subtitle}
                        </span>
                        <h3 className="text-sm sm:text-base font-bold mb-1 leading-tight" data-id="element-2467" data-mp="1pc9ciihc7602">
                          {banner.title}
                        </h3>
                        <p className="text-xs font-medium" data-id="element-2468" data-mp="1gbusdmg3zwy5">
                          {banner.description}
                        </p>
                      </div>
                    </a>)}
                </div>;
          })}
          </div>

          {/* Pagination dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-2469" data-mp="1bc84mj2nmyb3">
            {Array.from({
            length: totalPages
          }).map((_, i) => <button key={i} onClick={() => goToPage(i)} aria-label={`Go to page ${i + 1}`} className={`h-2 rounded-full transition-all ${activePage === i ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} data-id="element-2470" data-mp="35r0wc70f34xr" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </div>;
});